"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgMap = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M36 14v16a1 1 0 01-.504.868l-7 4-.025.014a.996.996 0 01-.065.032l.09-.046a1 1 0 01-.216.092l-.019.005a.907.907 0 01-.25.035h-.044a1 1 0 01-.078-.006L28 35a1.006 1.006 0 01-.445-.104l-.002-.002-7.522-3.76-6.535 3.734A1 1 0 0112 34V18a1 1 0 01.504-.868l7-4 .025-.014a.996.996 0 01.065-.032l-.09.046a1 1 0 01.216-.092l.019-.005A.907.907 0 0119.99 13H20.035a1 1 0 01.076.006L20 13a1.006 1.006 0 01.445.104l.002.002 7.522 3.76 6.535-3.734A1 1 0 0136 14zm-15 1.618v13.764l6 3V18.618l-6-3zm-2 .105l-5 2.857v13.697l5-2.858V15.723zm15 0l-5 2.857v13.696l5-2.856V15.723z",
    id: "map_svg__a"
  }));
};

var _default = SvgMap;
exports.default = _default;